import { useState } from "react";
import type { ExtractedMessage } from "@/__generated__/api/wrenAPI.schemas";

function Avatar({ name, side }: { name: string; side: "left" | "right" }) {
  const initial = name[0]?.toUpperCase() || "?";
  const bg = side === "left" ? "bg-[#c27a5a]" : "bg-[#638308]";

  return (
    <div
      className={`w-7 h-7 rounded-full ${bg} flex items-center justify-center text-white text-xs font-semibold flex-shrink-0`}
    >
      {initial}
    </div>
  );
}

export function MessageThread({ messages }: { messages: ExtractedMessage[] }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-[#fdfcfa] rounded-2xl shadow-[0_1px_10px_rgba(0,0,0,0.08)] overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 flex items-center justify-between text-left"
      >
        <span className="text-xs font-semibold text-[#999] uppercase tracking-wider">
          Conversation ({messages.length} messages)
        </span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#999"
          strokeWidth="2"
          className={`transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
        >
          <path d="M6 9L12 15L18 9" />
        </svg>
      </button>

      {isOpen && (
        <div className="px-6 pb-6 space-y-4">
          {messages.map((msg, i) => {
            const isRight = msg.side === "right";

            return (
              <div
                key={i}
                className={`flex items-end gap-2 animate-analyze-message-in ${
                  isRight ? "flex-row-reverse" : "flex-row"
                }`}
                style={{ animationDelay: `${i * 40}ms` }}
              >
                <Avatar name={msg.sender_name} side={msg.side} />
                <div className={`max-w-[75%] ${isRight ? "items-end" : "items-start"} flex flex-col`}>
                  <span className={`text-xs text-[#888] mb-1 px-1 ${isRight ? "text-right self-end" : ""}`}>
                    {msg.sender_name}
                  </span>
                  <div
                    className={`rounded-2xl px-4 py-2 text-sm leading-relaxed ${
                      isRight
                        ? "bg-[#638308] text-white rounded-br-md"
                        : "bg-[#e8e4db] text-[#1a1a1a] rounded-bl-md"
                    }`}
                  >
                    {msg.content}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
